const axios = require('axios');
import Utils from '../../helpers/Utils';

class SecureAPI {

    static APP_DATA_STORAGE = "vuex";
    static JSON_PARSE_ERROR = "JSON_PARSE_ERROR";
    static STATUS_SUCCESS = "SUCCESS";
    static LOCAL_NPM_SERVER = "http://localhost:3000";
    static SECURE_HOST = "http://localhost:8080";
    static SECURE_ROOT_DIR = "/api";
    config = {
        url: "",
        headers: {
            "Content-Type": "application/json",
            Authorization: ""
        }
    }
    authRequired = true;

    constructor(enableAuth = true) {
        let host = SecureAPI.getHost();
        this.authRequired = enableAuth;
        this.config.url = host + SecureAPI.SECURE_ROOT_DIR;
    }

    /**
     * Secure version of API class. 
     * @param {*} entityName the name of the endpoint in backend. eg: config.url + '/' + [entityName]
     * @param {*} params parameters will be appended on the final endpoint URL (GET method)
     */
    async get(entityName, params = {}){
        this.updateSession();
        return await axios.get(this.getEntityRouteURL(entityName), { params: params, headers: this.config.headers});
    }

    async post(entityName, params = {}){
        this.updateSession();
        return await axios.post(this.getEntityRouteURL(entityName), params, { headers: this.config.headers });
    }

    async put(){}

    async patch(){}

    async delete(entityName, params = {}){
        this.updateSession();
        return await axios.delete(this.getEntityRouteURL(entityName), { data: params, headers: this.config.headers });
    }

    getEntityRouteURL(entityName){
        return this.config.url + '/' + entityName;
    }

    updateSession() {
        if(!this.authRequired) return;
        let sessionId = this.getSessionId();
        this.config.headers["Authorization"] = (sessionId !== null && sessionId != "") ? "Bearer " + sessionId : "";
    }

    getSessionId(){
        let jsonString = localStorage.getItem(SecureAPI.APP_DATA_STORAGE);
        if (Utils.isEmpty(jsonString)) return "";

        try {
            let jsonObject = JSON.parse(jsonString);
            return jsonObject.user.session;
        } catch (err) {
            //Failed to parse
            console.log(err, SecureAPI.JSON_PARSE_ERROR);
            return SecureAPI.JSON_PARSE_ERROR;
        }
    }

    static getHost() {
        return Utils.startsWith(SecureAPI.LOCAL_NPM_SERVER, window.location.href) ? SecureAPI.SECURE_HOST : "";
    }

    static defaultError(err){
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        }
    }
}

export default SecureAPI;
